var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56982 8.66668H21.4302C20.0573 4.78285 16.354 2 12 2C7.64607 2 3.94271 4.78285 2.56982 8.66668Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 13.1689 2.20125 14.2907 2.5698 15.3333H21.4302C21.7987 14.2907 22 13.1689 22 12C22 10.8311 21.7987 9.70934 21.4302 8.66668H2.5698C2.20125 9.70934 2 10.8311 2 12Z",
    fill: "#00966E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4302 15.3333H2.56982C3.94271 19.2171 7.64607 22 12 22C16.354 22 20.0573 19.2171 21.4302 15.3333Z",
    fill: "#D62612"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBg);
export default __webpack_public_path__ + "static/media/flag-bg.275bb5a4a3ee3381668272e9c2c96799.svg";
export { ForwardRef as ReactComponent };